import React, {Fragment, useState} from "react";
import {Button, Col, Row} from "antd";
import {compose} from "redux";
import {translate} from "react-i18next";
import Selector from "../../../../../components/selector";
import EnhancedModal from "../../../../../components/enhanced-modal";
import InfiniteScrollTable from "../../../../../components/infinite-scroll-table";
import {MODAL_WIDTH_LG, SPAN_ONE_QUARTER, SPAN_THREE_QUARTERS} from "../../../../../styles/constants";


const ArtefactSelector = ({
                              t,
                              value,
                              choices,
                              columns,
                              onChange,
                              modalTitle,
                              selectTitle,
                              resetTitle,
                              disabled,
                              label,
                              style = {}
                          }) => {
    const [showModal, setShowModal] = useState(false);
    return <Fragment>
        <Row type="flex" align="middle" style={style}>
            <Col span={SPAN_ONE_QUARTER}>
                {label ? `${label}: ` : null}
            </Col>
            <Col span={SPAN_THREE_QUARTERS}>
                <Selector
                    value={value || null}
                    selectTitle={selectTitle}
                    resetTitle={resetTitle}
                    onSelect={() => setShowModal(true)}
                    onReset={() => onChange(null)}
                    disabled={disabled}
                />
            </Col>
        </Row>
        <EnhancedModal
            visible={showModal}
            title={modalTitle}
            footer={<Button
                onClick={() => setShowModal(false)}>{t('commons.buttons.close.title')}</Button>}
            onCancel={() => setShowModal(false)}
            width={MODAL_WIDTH_LG}
        >
            <InfiniteScrollTable
                data={choices || []}
                getRowKey={({name}) => name}
                columns={columns}
                onRowClick={(row) => {
                    onChange(row);
                    setShowModal(false);
                }}
            />
        </EnhancedModal>
    </Fragment>
};

export default compose(
    translate()
)(ArtefactSelector);